import PicUpload from '../pic-upload.vue';
export default {
  components: {
    PicUpload
  },
  data() {
    return {
      isShowDialog: false,
      content: "",
      pic: ""
    };
  },
  methods: {
    show() {
      this.isShowDialog = true;
    },
    cancel() {
      this.$refs.picUupload.handleRemove();
      this.content = "";
      this.pic = "";
      this.isShowDialog = false;
    },
    uploadFile() {
      if (!this.content) {
        this.$message({
          message: "请填写反馈内容",
          type: "error",
          duration: 1500
        });
        return;
      }
      this.$message({
        message: "提交成功",
        type: "success",
        duration: 1500
      });
      this.cancel();
      // this.$axios.post(
      //   '/complaint/save',
      //   {
      //     content:this.content,
      //     attachment:this.pic
      //   }
      // ).then((res)=>{
      //   this.cancel()
      // })
    }
  }
};